
import { ActionCellData } from "services/WebSocketService/types/ActionCellData";
import styles from "./PromotionDialog.module.css"

export const PromotionDialog: React.FC<{
	actionData: ActionCellData;
	onSelect: (piece: string, actionData: ActionCellData) => void;
	onClose: () => void;
  }> = ({ actionData, onSelect, onClose }) => {
	return (
	  <div className={styles.dialogBackdrop}>
		<div className={styles.dialog}>
		  <h3>Select Piece for Promotion</h3>
		  {actionData.data.promotion_options ? actionData.data.promotion_options.map((option) => (
			<button key={option} onClick={() => onSelect(option, actionData)}>
			  {option.charAt(0).toUpperCase() + option.slice(1)}
			</button>
		  )): <></>}
		  <button onClick={onClose}>Cancel</button>
		</div>
	  </div>
	);
  };